// lp-2-s1__battery-image-wrapperが画面の中央に入ったらlp-2-s1の背景を透明にしてlp-2-s2__bgが見えるようにする
document.addEventListener("DOMContentLoaded", function () {
  // lp-2-s9のSplideスライダー初期化
  const lp2S9SplideElement = document.querySelector("#lp-2-s9-splide");
  if (lp2S9SplideElement) {
    const lp2S9Splide = new Splide(lp2S9SplideElement, {
      type: "loop",
      pauseOnHover: false,
      pauseOnFocus: false,
      fixedWidth: "15.65rem",
      gap: "1rem",
      pagination: false,
      arrows: false,
      perMove: 1,
      perPage: 1,
      breakpoints: {
        768: {
          fixedWidth: "14.65rem",
          gap: "0.625rem",
        },
      },
    });

    const bar = document.querySelector(
      "#lp-2-s9-splide .lp-2-s9__splide-progress-bar"
    );

    if (bar) {
      lp2S9Splide.on("mounted move", function () {
        const end = lp2S9Splide.Components.Controller.getEnd() + 1;
        const rate = Math.min((lp2S9Splide.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + "%";
      });
    }

    lp2S9Splide.mount();
  }

  // lp-2-s10__imagesが見えたら、lp-2-s10__image-wrapper2からlp-2-s10__image-wrapper4まで順番に表示
  const lp2S10Images = document.querySelector(".lp-2-s10__images");
  if (lp2S10Images) {
    const imageWrapper2 = document.querySelector(".lp-2-s10__image-wrapper2");
    const imageWrapper3 = document.querySelector(".lp-2-s10__image-wrapper3");
    const imageWrapper4 = document.querySelector(".lp-2-s10__image-wrapper4");

    if (imageWrapper2 && imageWrapper3 && imageWrapper4) {
      const s10Observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // 順番に表示（各300ms間隔）
              setTimeout(function () {
                imageWrapper2.classList.add("is-visible");
              }, 500);

              setTimeout(function () {
                imageWrapper3.classList.add("is-visible");
              }, 1000);

              setTimeout(function () {
                imageWrapper4.classList.add("is-visible");
              }, 1500);

              // 一度表示したら監視を停止
              s10Observer.unobserve(lp2S10Images);
            }
          });
        },
        {
          threshold: 0.1, // 10%が見えたら発火
        }
      );

      s10Observer.observe(lp2S10Images);
    }
  }

  // lp-2-s15のレビュースライダー初期化（スマホ時のみ）
  const lp2S15ReviewSwiperElement = document.querySelector(
    "#lp-2-s15-review-swiper"
  );
  let lp2S15ReviewSwiper = null;

  function initLp2S15Swiper() {
    if (!lp2S15ReviewSwiperElement || typeof Swiper === "undefined") return;

    // PC時（768px以上）はスライダーを破棄
    if (window.innerWidth >= 768) {
      if (lp2S15ReviewSwiper) {
        lp2S15ReviewSwiper.destroy(true, true);
        lp2S15ReviewSwiper = null;
      }
      return;
    }

    // スマホ時のみスライダーを初期化
    if (!lp2S15ReviewSwiper) {
      lp2S15ReviewSwiper = new Swiper("#lp-2-s15-review-swiper", {
        loop: true,
        centeredSlides: true,
        slidesPerView: 1.342,
        spaceBetween: 21.02,
        pagination: false,
        navigation: false,
        loopAdditionalSlides: 1,
      });
    }
  }

  // 初回実行
  initLp2S15Swiper();

  // リサイズ時に再チェック
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initLp2S15Swiper();
    }, 250);
  });

  // // lp-2-0 用グラフ（簡略版）
  // const lp2Canvas = document.getElementById("lp2HealthGraph");
  // const lp2ScoreDisplayElement = document.getElementById("lp2-score-display");
  // if (!lp2Canvas || !lp2ScoreDisplayElement) return;

  // const lp2Ctx = lp2Canvas.getContext("2d");
  // const lp2Container = lp2Canvas.closest(".lp-2-graph__container");
  // const lp2Scores = [35, 48, 40, 61, 55, 79, 93];
  // const lp2TodayScore = lp2Scores[lp2Scores.length - 1];
  // const config = {
  //   color: "#FFFFFF",
  //   glow: "rgba(255, 255, 255, 0.85)",
  //   pointRadius: 3,
  //   lineWidth: 1.2,
  //   curveTension: 0.0,
  //   speed: 0.007,
  //   loopDelay: 3000,
  // };

  // let progress = 0;
  // let timeoutId = null;
  // let padding, graphW, graphH, pointDistX, scoreScaleY;

  // function setup() {
  //   const dpr = window.devicePixelRatio;
  //   lp2Canvas.width = lp2Container.clientWidth * dpr;
  //   lp2Canvas.height = lp2Container.clientHeight * dpr;
  //   lp2Ctx.setTransform(1, 0, 0, 1, 0, 0);
  //   lp2Ctx.scale(dpr, dpr);
  //   padding = { top: 50, right: 20, bottom: 20, left: 20 };
  //   graphW = lp2Container.clientWidth - padding.left - padding.right;
  //   graphH = lp2Container.clientHeight - padding.top - padding.bottom;
  //   pointDistX =
  //     lp2Scores.length > 1 ? graphW / (lp2Scores.length - 1) : graphW;
  //   scoreScaleY = graphH / 100;
  // }

  // function draw() {
  //   const dpr = window.devicePixelRatio;
  //   lp2Ctx.clearRect(0, 0, lp2Canvas.width / dpr, lp2Canvas.height / dpr);
  //   const segments = progress * (lp2Scores.length - 1);

  //   // 767px以下の時はrem単位、それ以外はconfigの値を使用
  //   const rootFontSize = parseFloat(
  //     getComputedStyle(document.documentElement).fontSize
  //   );
  //   const lineWidth =
  //     window.innerWidth <= 767 ? (0.1 * rootFontSize) / dpr : config.lineWidth;

  //   // 線を描画
  //   lp2Ctx.beginPath();
  //   lp2Ctx.lineWidth = lineWidth * dpr;
  //   lp2Ctx.strokeStyle = config.color;
  //   lp2Ctx.lineCap = "round";
  //   lp2Ctx.lineJoin = "round";
  //   lp2Ctx.shadowBlur = 15 * dpr;
  //   lp2Ctx.shadowColor = config.glow;

  //   const startX = padding.left;
  //   const startY = padding.top + graphH - lp2Scores[0] * scoreScaleY;
  //   lp2Ctx.moveTo(startX, startY);

  //   for (let i = 0; i < lp2Scores.length - 1; i++) {
  //     const segProgress = segments - i;
  //     if (segProgress <= 0) break;
  //     const x1 = padding.left + i * pointDistX;
  //     const y1 = padding.top + graphH - lp2Scores[i] * scoreScaleY;
  //     const x2 = padding.left + (i + 1) * pointDistX;
  //     const y2 = padding.top + graphH - lp2Scores[i + 1] * scoreScaleY;

  //     if (segProgress >= 1) {
  //       const cpX = x1 + (x2 - x1) * config.curveTension;
  //       const cpY = y1 + (y2 - y1) * config.curveTension;
  //       lp2Ctx.quadraticCurveTo(cpX, cpY, x2, y2);
  //     } else {
  //       const px = x1 + pointDistX * segProgress;
  //       const py = y1 + (y2 - y1) * segProgress;
  //       const cpX = x1 + (px - x1) * config.curveTension;
  //       const cpY = y1 + (py - y1) * config.curveTension;
  //       lp2Ctx.quadraticCurveTo(cpX, cpY, px, py);
  //     }
  //   }
  //   lp2Ctx.stroke();
  //   lp2Ctx.shadowBlur = 0;

  //   // ポイントを描画
  //   lp2Ctx.fillStyle = config.color;
  //   lp2Ctx.shadowBlur = 10 * dpr;
  //   lp2Ctx.shadowColor = config.glow;

  //   // 767px以下の時は0.251rem、それ以外はconfig.pointRadiusを使用
  //   const pointRadius =
  //     window.innerWidth <= 767
  //       ? (0.251 * rootFontSize) / dpr
  //       : config.pointRadius;

  //   for (let i = 0; i < lp2Scores.length; i++) {
  //     if (i <= segments || (i === 0 && segments >= 0) || progress >= 1) {
  //       const x = padding.left + i * pointDistX;
  //       const y = padding.top + graphH - lp2Scores[i] * scoreScaleY;
  //       lp2Ctx.beginPath();
  //       lp2Ctx.arc(x, y, pointRadius * dpr, 0, Math.PI * 2);
  //       lp2Ctx.fill();
  //     }
  //   }
  //   lp2Ctx.shadowBlur = 0;

  //   // スコア表示
  //   if (progress >= 1) {
  //     lp2ScoreDisplayElement.innerHTML = `${lp2TodayScore}<span class="lp2-score-pt">pt</span>`;
  //     lp2ScoreDisplayElement.style.opacity = "1";
  //     lp2ScoreDisplayElement.style.transform = "translateY(0) scale(1)";
  //   }
  // }

  // function animate() {
  //   setup();
  //   draw();
  //   if (progress < 1) {
  //     progress += config.speed;
  //     if (progress > 1) progress = 1;
  //     requestAnimationFrame(animate);
  //   }
  // }

  // requestAnimationFrame(animate);
});

// lp-2-s11__breathing-image-wrapper1が少し見えたらlp-2-s11__breathing-image-wrapper2を下からフェードイン
document.addEventListener("DOMContentLoaded", function () {
  const breathingImageWrapper1 = document.querySelector(
    ".lp-2-s11__breathing-image-wrapper1"
  );
  const breathingImageWrapper2 = document.querySelector(
    ".lp-2-s11__breathing-image-wrapper2"
  );

  if (breathingImageWrapper1 && breathingImageWrapper2) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // lp-2-s11__breathing-image-wrapper1が少し見えたら
            breathingImageWrapper2.classList.add("is-visible");
            // 一度表示したら監視を停止
            observer.unobserve(breathingImageWrapper1);
          }
        });
      },
      {
        threshold: 0.1, // 10%が見えたら発火
      }
    );

    observer.observe(breathingImageWrapper1);
  }
});
// lp-2-s19のスクロールヒント表示（スマホ時のみ、セッション内1回のみ）
document.addEventListener("DOMContentLoaded", function () {
  const scrollHint = document.querySelector(".lp-2-s19__scroll-hint");
  const imageWrapper = document.querySelector(".lp-2-s19__image-wrapper");

  if (scrollHint && imageWrapper) {
    // セッションストレージを確認
    // if (sessionStorage.getItem("lp2S19ScrollHintShown")) {
    //   return;
    // }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 表示
            scrollHint.classList.add("is-visible");
            // フラグを保存
            sessionStorage.setItem("lp2S19ScrollHintShown", "true");

            // ユーザー操作で非表示
            const hideHint = () => {
               scrollHint.classList.remove("is-visible");
               imageWrapper.removeEventListener("scroll", hideHint);
               imageWrapper.removeEventListener("touchstart", hideHint);
            };

            imageWrapper.addEventListener("scroll", hideHint);
            imageWrapper.addEventListener("touchstart", hideHint);

            // 監視停止
            observer.unobserve(imageWrapper);
          }
        });
      },
      {
        threshold: 0.5, // 50%が見えたら発火
      }
    );

    observer.observe(imageWrapper);
  }
});

// lp-2-s15のスクロールヒント表示（スマホ時のみ、セッション内1回のみ）
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth >= 768) return; // PCでは実行しない

  const scrollHint = document.querySelector(".lp-2-s15__scroll-hint");
  const wrapper = document.querySelector(".lp-2-s15__review-swiper-wrapper");

  if (scrollHint && wrapper) {
    // セッションストレージを確認
    // if (sessionStorage.getItem("lp2S15ScrollHintShown")) {
    //   return;
    // }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 表示
            scrollHint.classList.add("is-visible");
            // フラグを保存
            sessionStorage.setItem("lp2S15ScrollHintShown", "true");

            // ユーザー操作で非表示
            const hideHint = () => {
               scrollHint.classList.remove("is-visible");
               wrapper.removeEventListener("touchstart", hideHint);
               wrapper.removeEventListener("mousedown", hideHint);
            };

            wrapper.addEventListener("touchstart", hideHint);
            wrapper.addEventListener("mousedown", hideHint);

            // 監視停止
            observer.unobserve(wrapper);
          }
        });
      },
      {
        threshold: 0.5, // 50%が見えたら発火
      }
    );

    observer.observe(wrapper);
  }
});

// lp-2-s9のスクロールヒント表示（スマホ時のみ、セッション内1回のみ）
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth >= 768) return; // PCでは実行しない

  const scrollHint = document.querySelector(".lp-2-s9__scroll-hint");
  const wrapper = document.querySelector(".lp-2-s9__splide-wrapper");

  if (scrollHint && wrapper) {
    // セッションストレージを確認
    // if (sessionStorage.getItem("lp2S9ScrollHintShown")) {
    //   return;
    // }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 表示
            scrollHint.classList.add("is-visible");
            // フラグを保存
            sessionStorage.setItem("lp2S9ScrollHintShown", "true");

            // ユーザー操作で非表示
            const hideHint = () => {
              scrollHint.classList.remove("is-visible");
              wrapper.removeEventListener("touchstart", hideHint);
              wrapper.removeEventListener("mousedown", hideHint);
            };

            wrapper.addEventListener("touchstart", hideHint);
            wrapper.addEventListener("mousedown", hideHint);

            // 監視停止
            observer.unobserve(wrapper);
          }
        });
      },
      {
        threshold: 0.5, // 50%が見えたら発火
      }
    );

    observer.observe(wrapper);
  }
});

// lp-2-s17 アコーディオン
document.addEventListener("DOMContentLoaded", function () {
  const accordionButtons = document.querySelectorAll(
    ".lp-2-s17__accordion-button"
  );

  accordionButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const accordion = this.closest(".lp-2-s17__accordion");
      const moreContent = accordion.querySelector(".lp-2-s17__accordion-more");
      const isOpen = this.getAttribute("aria-expanded") === "true";
      const openText = this.getAttribute("data-open-text");
      const closeText = this.getAttribute("data-close-text");

      if (isOpen) {
        // 閉じる
        moreContent.style.display = "none";
        this.setAttribute("aria-expanded", "false");
        this.textContent = openText;
      } else {
        // 開く
        moreContent.style.display = "block";
        this.setAttribute("aria-expanded", "true");
        this.textContent = closeText;
      }
    });
  });


  const koteiBtn = document.querySelector(".c-kotei-btn");
  const mvSection = document.getElementById("lp-2-mv");

  if (koteiBtn && mvSection) {
    const checkVisibility = () => {
      const mvRect = mvSection.getBoundingClientRect();
      if (mvRect.bottom < 0) {
        koteiBtn.classList.add("is-visible");
      } else {
        koteiBtn.classList.remove("is-visible");
      }
    };

    window.addEventListener("scroll", checkVisibility);
    checkVisibility();
  }
});
